<template>
	<div>
		<!-- page content -->
		<v-row dense class="fill-height ma-0">
			<v-col
				md="3"
				cols="12"
				class="pt-2 rounded-lg grey lighten-3"
			>
				<!-- search -->
				<div class="d-flex align-center mb-2 px-1">
					<v-autocomplete
						v-model="openItemId"
						:label="$T('inputs.role-name')"
						:items="roles"
						item-text="name"
						item-value="id"
						dense
						outlined
						hide-details
						class="me-1"
						@change="activeNode = [openItemId]; selectActiveAccount(openItemId)"
					></v-autocomplete>

					<v-btn
						v-if="permissions.users.isReadWrite"
						depressed
						height="32"
						min-width="0"
						color="primary"
						class="px-2"
						:disabled="disableState"
						:to="{ name: 'role' }"
					>
						<v-icon>$add</v-icon>
						{{$T('add')}}
					</v-btn>
				</div>

				<!-- tree -->
				<v-progress-linear v-if="loading" indeterminate/>
				<bee-treeview
					:items="loading ? [] : roles"
					dense
					hoverable
					activatable
					class="items-tree"
					root-class="primary--text font-weight-medium"
					active-class="success--text"
					expand-icon="mdi-chevron-down"
					:open-item.sync="openItemId"
					:active.sync="activeNode"
					:open.sync="openNodes"
					calculate-width
					:disabled="disableState"
					:calculate-threshold="-0.1"
					:disable-context-menu="!permissions.users.isReadWrite"
					:context-menu-items="permissions.users.isReadWrite ? contextmenuItems : []"
					@context-menu-edit="item => {
						activeNode = [item.id];
						$router.replace({ name: 'role', params: { id: item.id } })
					}"
					@context-menu-delete="item => {
						activeNode = [item.id];
						$router.replace({ name: 'role', params: { id: item.id }, query: { preview: 1, delete: 1 } })
					}"
					@click="selectActiveAccount"
				></bee-treeview>
			</v-col>
			<v-col md="9" cols="12">
				<div
					v-if="$route.name === 'roles-management' || loading"
					class="d-flex flex-column justify-center align-center fill-height"
				>
					<v-img
						src="@/assets/skills.png"
						width="180"
						max-height="180"
						class="mb-4"
					/>
					<p
						class="text-h6 grey--text text--darken-2 ma-0"
					>{{loading ? $T('loading-roles') : $T('please-select-a-role')}}</p>
				</div>
				<router-view
					v-else
					@update-roles="fetchRoles(true)"
					@change-disable-state="e => disableState = e"
					class="pa-3 py-md-0"
				></router-view>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'RolesManagement',

	data() {
		return {
			loading: false,
			deleteDialog: false,
			
			disableState: false,

			openItemId: null,
			activeNode: [],
			openNodes: [],
		}
	},

	computed: {
		...mapState({
			permissions: state => state.auth.self.permissions,
			roles: state => state.roles.roles,
		}),

		contextmenuItems() {
			return [
				{
					title: this.$T('edit'),
					event: 'edit',
					class: 'warning-color--text',
					icon: '$edit',
					iconColor: 'warning-color',
					iconClass: 'me-1'
				},
				{
					title: this.$T('delete'),
					event: 'delete',
					class: 'alert-color--text',
					icon: '$delete',
					iconColor: 'alert-color',
					iconClass: 'me-1'
				}
			]
		}
	},

	methods: {
		selectActiveAccount(data) {
			let item = data;
			if (typeof item === 'string') {
				item = this.roles.find(c => c.id === item);
			}
			
			this.activeNode.push(item.id);
			this.openNodes.push(item.id);
			if (this.$route.params.id !== item.id) {
				this.$router.replace({
					name: 'role',
					params: { id: item.id },
					query: { preview: 1 },
				})
			}
		},
		
		fetchRoles(forceUpdate = false) {
			if (!this.roles.length || forceUpdate) {
				this.loading = true;
				this.$store.dispatch('roles/fetchAll').finally(() => {
					this.loading = false;
				})
			}
		}
	},

	created() {
		this.fetchRoles();
	}
}
</script>

<style>

</style>